import React, { useEffect } from "react";
import NavbarMystio from "../../Components/MystioNew/NavbarMystio";
import HeroMystio from "../../Components/MystioNew/HeroMystio";
import IntroMystio from "../../Components/MystioNew/IntroMystio";
import MapSectionMystio from "../../Components/MystioNew/MapSectionMystio";
import ServicesMystio from "../../Components/MystioNew/ServicesMystio";
import ShopNowMystio from "../../Components/MystioNew/ShopNowMystio";
import BlueBannerMystio from "../../Components/MystioNew/BlueBannerMystio";
import FooterMystio from "../../Components/MystioNew/FooterMystio";
import { scrollToTop } from "../../helper/helper";

export default function MystioNew() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white flex flex-col justify-between overflow-x-hidden">
      <div>
        {/* Navbar */}
        <NavbarMystio />

        {/* Hero Section */}
        <HeroMystio />

        {/* Introduction */}
        <IntroMystio />

        {/* Ochre Map Section */}
        <MapSectionMystio />

        {/* Services Section */}
        <ServicesMystio />

        {/* Shop Now CTA Section */}
        <ShopNowMystio />
      </div>

      {/* Footer & Notification Banner */}
      <div>
        <BlueBannerMystio />
        <FooterMystio />
      </div>
    </div>
  );
}
